import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Proveedor } from "@/shared/types/proveedor"; 
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ProveedoresQuery extends BaseQuery {
    nombre?: string,
    numDocumento?: string,
    telefono?: string,
    direccion?: string,
    email?: string,
}

export async function getAllProveedores(query?: ProveedoresQuery): Promise<QueryResponse<Proveedor>> {
    await sleep(1000);
    const response = await api.get("proveedores", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllProveedoresQuery(query: ProveedoresQuery = {}, queryConfig: QueryConfig<QueryResponse<Proveedor>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllProveedores(query),
        queryKey: ["proveedores", query],
    })
}

export interface GetAllProveedorQueryProps{
    query:ProveedoresQuery,
    queryConfig?: QueryConfig<QueryResponse<Proveedor>>,
    children:(queryResult:QueryResult<QueryResponse<Proveedor>>)=>ReactNode
}

export function GetAllProveedoresQuery({
    query,
    queryConfig,
    children
}:GetAllProveedorQueryProps){
    const queryResult = useGetAllProveedoresQuery(query, queryConfig);
    return children&&children(queryResult);
}